import { c as _c } from "react/compiler-runtime";
import { isEmail } from '@onefootprint/core';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormInput, { type FormInputProps } from './form-input';
export type FormEmailProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'type' | 'autoComplete'>;
export default function FormEmail(t0) {
  const $ = _c(11);
  let props;
  let rules;
  if ($[0] !== t0) {
    ({
      rules,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = rules;
  } else {
    props = $[1];
    rules = $[2];
  }
  const {
    t
  } = useTranslation("ui");
  let t1;
  if ($[3] !== t) {
    t1 = value => {
      if (!value) {
        return true;
      }
      if (!isEmail(value)) {
        return t(_temp);
      }
      return true;
    };
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rules || $[6] !== t1) {
    t2 = {
      validate: t1,
      ...rules
    };
    $[5] = rules;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const emailRules = t2;
  let t3;
  if ($[8] !== emailRules || $[9] !== props) {
    t3 = <FormInput {...props} rules={emailRules} autoComplete="email" inputMode="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} />;
    $[8] = emailRules;
    $[9] = props;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp($) {
  return $.components.form.email.errors.invalid;
}